import { render, staticRenderFns } from "./ArtistVideoBox.vue?vue&type=template&id=fa9ae908&"
import script from "./ArtistVideoBox.vue?vue&type=script&lang=ts&"
export * from "./ArtistVideoBox.vue?vue&type=script&lang=ts&"
import style0 from "./ArtistVideoBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports